<template>
  <div>
    <h2
      style="margin: 20px 0; font-size: 16px; float: left; width: 100%"
      v-if="!isOne"
    >
      <span>
        <Checkbox
          :indeterminate="indeterminate"
          :value="checkAll"
          @click.prevent.native="handleCheckAll"
          >全选</Checkbox
        >
      </span>
    </h2>
    <ul id="dasdrrea" class="gundongtiao" v-if="!isOne">
      <CheckboxGroup v-model="alarmTypeIdList" @on-change="checkAllGroupChange">
        <li
          style="width: 100%"
          v-for="(item, index) in alarmTypeList"
          :key="index"
        >
          <Checkbox :key="item.alarmTypeId" :label="item.alarmTypeId">{{
            item.name
          }}</Checkbox>
        </li>
      </CheckboxGroup>
    </ul>
    <ul id="dasdrrea1" class="gundongtiao" v-if="isOne">
      <li
        style="width: 100%"
        v-for="(item, index) in alarmTypeList"
        :key="index"
        @click="selectAlarm(item)"
      >
        {{ item.name }}
      </li>
    </ul>
  </div>
</template>
<script>
import axios from "axios";
var allAlarm = [];
export default {
  props: ["isOne", "alarmFill"],
  data() {
    return {
      checkAll: false,
      indeterminate: false,
      alarmTypeIdList: [],
      alarmTypeList: [],
    };
  },
  methods: {
    //获取报警类型列表
    getAlarmTypeList() {
      axios({
        method: "post",
        url: "/dictionary/item",
        data: {
          keyword: "alarmAscType",
        },
      }).then((res) => {
        var data = JSON.parse(res.data.data.value);
        for (let i = 0; i < data.length; i++) {
          var obj = {
            alarmTypeId: data[i].id,
            name: data[i].name,
          };
          this.alarmTypeList.push(obj);
          allAlarm[i] = obj.alarmTypeId;

          //this.alarmTypeIdList[i] = obj.alarmTypeId; //全选
          //全选
          //this.$emit("alarmData", allAlarm);
        }
      });
    },
    //报警模式点击全选
    handleCheckAll() {
      if (this.indeterminate) {
        this.checkAll = false;
      } else {
        this.checkAll = !this.checkAll;
      }
      this.indeterminate = false;
      console.log(allAlarm);
      if (this.checkAll) {
        this.alarmTypeIdList = allAlarm;
      } else {
        this.alarmTypeIdList = [];
      }
      this.$emit("alarmData", this.alarmTypeIdList);
    },
    //点击报警选项
    checkAllGroupChange(data) {
      if (data.length === allAlarm.length) {
        this.indeterminate = false;
        this.checkAll = true;
      } else if (data.length > 0) {
        this.indeterminate = true;
        this.checkAll = false;
      } else {
        this.indeterminate = false;
        this.checkAll = false;
      }
      this.$emit("alarmData", data);
    },
    selectAlarm(v) {
      this.$emit("alarm", v);
    },
  },
  mounted() {
    this.getAlarmTypeList();
  },
};
</script>
<style lang="">
#dasdrrea {
  height: calc(100% - 80px);
  width: 100%;
  overflow: auto;
  float: left;
}
#dasdrrea li {
  padding: 6px;
}
#dasdrrea li:hover {
  background: #e2f1ff;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/common/alarmSafeTool.vue